import { chakra } from "@chakra-ui/system"
import { Link as ReactRouterLink } from "react-router-dom"

export const Link = chakra(ReactRouterLink)
